import mod from "-!../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RegionToolbar.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RegionToolbar.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/annotations/annotations-ui/RegionToolbar.vue?vue&type=script&lang=js&
// module id = 128
// module chunks = 0